/* eslint-disable max-len */
import { LicenseType } from '../api/enumerations';

export const Constants = {
  openToAccreditation: 'aberto a credenciamento pelo Proto',
  visibleToProto: 'Permitir visualização do edital pelo credenciado',
  activateVisibility:
    ' Ao ativar, o edital ficará visível para os credenciados no Proto.',
  accreditationDocuments: 'Documentos para credenciamento',
  licenseTypesAccepted: 'Registro profissional aceito',
  defineDocuments:
    'Defina os documentos que o prestador de serviço deverá assinar ou aceitar ao solicitar credenciamento neste edital.',
  addDocumentToAccept: 'Adicionar documento para aceite',
  contractService: 'Contrato de Prestação de Serviço *',
  dragAndDropgFile: 'Clique para selecionar ou arraste o arquivo',
  allowedFormat: 'Formatos permitidos: PDF • Tamanho máximo: 10MB',
  signDocObs:
    'O prestador deverá baixar, assinar e anexar este documento para concluir o credenciamento.',
  acceptDocObs:
    'O prestador de serviço precisará ler e confirmar o aceite deste documento durante o credenciamento.',
  docName: 'Nome do documento',
  removeFromNotice: 'Remover do edital',
  editDoc: 'Editar documento',
  addDoc: 'Adicionar documento',
  saveDoc: 'Salvar alterações',
  cancel: 'Cancelar',
  onlyPdfAllowed: 'Apenas arquivos PDF são permitidos.',
  fileTooLarge: 'O arquivo deve ter no máximo 10MB.',
  removeContractTitle: 'Remover Contrato?',
  removeContractSubtitle:
    'Você precisará anexar um novo arquivo antes de criar o edital.',
  removeExtraTitle: 'Remover documento do edital?',
  removeLabel: 'Remover',
  removeDocumentLabel: 'Remover documento',
  removeExtraSubtitle:
    'O documento {{docName}} será removido. O prestador de serviço não precisará mais aceitar este documento no credenciamento.',
  duplicateDocName: 'Já existe um documento com este nome.',
  searchCompany: 'buscar empresa',
  clearSearch: 'limpar busca',
  noRequestsRegistered: 'Nenhum pedido cadastrado.',
  noRequestsFound: 'Nenhum pedido encontrado.',
  createNotice: 'Criar edital',
  confirmChanges: 'Confirmar alterações',
  awaitingProviderAdvance:
    'Aguardando o credenciado avançar para a formalização do contrato.',
  awaitingSignedContract:
    'Solicitação em formalização, aguardando o envio do contrato assinado pelo credenciado.',
  formalizationUnderReview:
    'Solicitação em formalização de contrato, verifique os documentos.',
};

export const LICENSE_TYPE_OPTIONS: LicenseType[] = [
  LicenseType.CREA,
  LicenseType.CAU,
  LicenseType.CNAI,
];
